import React from 'react';

import { COLORS } from 'Components/foundation';
import UIcon from 'Components/unit/UIcon/UIcon';
import UImage from 'Components/unit/UImage/UImage';

import styles from '../Item.styles';

interface ActivityImageProps {
  image?: string | null;
}

export const ActivityImage: React.FC<ActivityImageProps> = ({ image }) => (
  <div style={styles.containerImage}>
    {image ? (
      <div style={styles.imageContainer}>
        <UImage
          style={styles.image}
          src={image}
          transformation={{
            height: 162 * 2,
            width: 162 * 2,
          }}
        />
      </div>
    ) : (
      <UIcon name="image" size={70} color={COLORS.GREY_DARK.DEFAULT} />
    )}
  </div>
);

export default ActivityImage;
